import { useLandscapeLock } from "@/hooks/useLandscapeLock";
import { useWakeLock } from "@/hooks/useWakeLock";
import { useUpdateChecker } from "@/hooks/useUpdateChecker";
import { UpdateAvailableModal } from "@/components/global/UpdateAvailableModal";
import Routes from "@/routes/index";

function App() {
  useLandscapeLock(true);
  useWakeLock(true);
  const { updateAvailable, updateInfo, dismiss } = useUpdateChecker();

  return (
    <>
      <div className="flex h-full min-h-0 max-h-full flex-col overflow-hidden">
        <Routes />
      </div>
      {updateAvailable && updateInfo && (
        <UpdateAvailableModal
          version={updateInfo.version}
          apkUrl={updateInfo.apkUrl}
          onDismiss={dismiss}
        />
      )}
    </>
  );
}

export default App;
